import i18n from '@/i18n'
export default {
  columns: (vm) => {
    return [{
      title: i18n.t('alert.columns.114421-0'),
      type: 'index',
      width: 120,
      align: 'center',
      indexMethod: (row) => {
        return (vm.query.page - 1) * vm.query.size + row._index + 1;
      }
    },{
      title: i18n.t('alert.columns.114421-1'),
      key: 'UserDeviceName',
      resizable: true,
      minWidth: 160,
      sortable: true,
      align: 'center'
    },
    {
      title: i18n.t('alert.columns.114421-2'),
      key: 'DeviceCode',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('alert.columns.114421-3'),
      key: 'CreateTime',
      resizable: true,
      sortable: true,
      minWidth: 190,
      align: 'center'
    },
    {
      title: i18n.t('alert.columns.114421-4'),
      key: 'AbnormalName',
      resizable: true,
      sortable: true,
      minWidth: 190,
      align: 'center'
    },
    {
      title: i18n.t('alert.columns.114421-5'),
      key: 'OwnerName',
      resizable: true,
      sortable: true,
      minWidth: 190,
      align: 'center'
    },
    {
      title: i18n.t('alert.columns.114421-6'),
      key: 'AddressDetail',
      resizable: true,
      sortable: true,
      minWidth: 190,
      align: 'center'
    },
    {
      title: i18n.t('alert.columns.114421-7'),
      key: 'Longitude',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('alert.columns.114421-8'),
      key: 'Latitude',
      resizable: true,
      sortable: true,
      minWidth: 160,
      align: 'center'
    },
    {
      title: i18n.t('alert.columns.114421-9'),
      key: 'action',
      width: 200,
      minWidth:150,
      align: 'center',
      fixed: 'right',
      render: (h, params) => {
        let action = [];
        if (params.row.ProcessStatus === 1) {
          action = [
            h('Button', {
              props: {
                type: 'info',
                size: 'small'
              },
              style: {
                marginRight: '5px'
              },
              on: {
                click: () => {
                  vm.SolveAbData(params.row.Id, 2)
                }
              }
            }, i18n.t('alert.columns.114421-10')),
            h('Button', {
              props: {
                type: 'warning',
                size: 'small'
              },
              on: {
                click: () => {
                  vm.SolveAbData(params.row.Id, 3)
                }
              }
            }, i18n.t('alert.columns.114421-11'))
          ]
        } else {
          action = [h('span', {}, params.row.ProcessStatus === 2 ? i18n.t('alert.columns.114421-12') : params.row.ProcessStatus === 3 ? i18n.t('alert.columns.114421-11') : i18n.t('alert.columns.114421-13'))]
        }
        return h('div', action);
      }
    }]
  }
}



// WEBPACK FOOTER //
// ./src/components/useGas/views/alert/columns.js